import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { UsersIamDivisionChoice } from '@r1-compass-library/models';

@Component({
    selector: 'r1-compass-app-select-division',
    imports: [MatButtonModule],
    template: `
        <section>
            <h2>Select Division</h2>
            <div id="divisions">
                @for (division of divisions(); track $index) {
                    <button mat-flat-button class="division" (click)="selectDivision.emit(division)" type="button">
                        {{ division.divisionCode }}
                    </button>
                }
            </div>
        </section>
    `,
    styleUrl: './select-division.component.scss',
})
export class SelectDivisionComponent {
    divisions = input.required<UsersIamDivisionChoice[]>();
    selectDivision = output<UsersIamDivisionChoice>();
}
